// Map style: Acciones are red dots and lines (navy when highlighted), territories navy outlines over gray.
export const ACTION_DOT_COLOR = '#E0201B';
export const NAVY = '#384078';

export const ACTION_DOT_RADIUS = 6;
export const ACTION_DOT_ACTIVE_RADIUS = 9;

export const TERRITORY_STYLE = {
  strokeColor: NAVY,
  strokeWeight: 2,
  fillColor: '#8C8C8C',
  fillOpacity: 0.3
};

export const TERRITORY_ACTIVE_STYLE = {
  ...TERRITORY_STYLE,
  strokeWeight: 3,
  fillOpacity: 0.5
};
